import React, { PureComponent } from "react";
import "./service.css";

export default class Service extends PureComponent {
    static get propTypes() {
        return {
            name: React.PropTypes.string.isRequired,
            price: React.PropTypes.oneOfType([
                React.PropTypes.string,
                React.PropTypes.number,
            ]).isRequired,
        };
    }

    render() {
        return (
            <div className="appointment-service">
                <div className="appointment-service__name">
                    {this.props.name}
                </div>

                {<div className="appointment-service__price">
                    {this.props.price}р
                </div>}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/service.js
 **/